export interface RichTextNode {
  nodeType: string;
  content?: RichTextNode[];
  value?: string;
  marks?: { type: string }[];
  data?: unknown;
}

export enum RichTextNodeType {
  Paragraph = 'paragraph',
  Heading1 = 'heading-1',
  Heading2 = 'heading-2',
  Heading3 = 'heading-3',
  Heading4 = 'heading-4',
  Heading5 = 'heading-5',
  Heading6 = 'heading-6',
  Hyperlink = 'hyperlink',
  EntryHyperlink = 'entry-hyperlink',
  UnorderedList = 'unordered-list',
  OrderedList = 'ordered-list',
  Blockquote = 'blockquote',
  Hr = 'hr',
}
